import FoodItemHeader, { FoodItemHeaderProps } from './FoodItemHeader';

export type { FoodItemHeaderProps };
export default FoodItemHeader;
